<template>
  <input
    ref="inputRef"
    type="text"
    class="form-control"
    :disabled="disabled"
  />
</template>

<script>
import { useCurrencyInput } from "vue-currency-input";

export default {
  name: "CurrencyInput",
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    options: {
      type: Object,
      default: () => ({
        currency: "BRL",
        locale: "pt-BR",
        autoDecimalDigits: true,
        exportValueAsInteger: true,
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { inputRef, setValue, setOptions } = useCurrencyInput(
      props.options
    );

    return { inputRef, setValue, setOptions };
  },
  watch: {
    value(newVal) {
      this.setValue(newVal);
    },
    options(newOptions) {
      this.setOptions(newOptions);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control {
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  font-size: 15px;
  width: 100%;

  &:focus {
    border-color: #b23066;
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(178, 48, 102, 0.15);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }
}
</style>
